module.exports = __webpack_public_path__ + "static/media/CheckMark.eb2e0f7c.png";